import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import axios from "axios";
import $ from "jquery";
import { AJAROOT } from "@/common/gdata/global.js";
import queryString from "query-string";
import {
  checkUserLogin,
  getUserIndexData,
  MyToast,
  MyToastShow,
} from "@/jscript/common.js";

import "@/css/user.css";
import rjt from "../../../statics/rjt.png";
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //  myu: "",
      editid: "",

      giftcode: "",
      gifttype: "price",
      price: "",
      services: [],
      used: 0,

      postresult: "",
      servicelist: [],
      selectedlist: [],
      mytoast: {
        show: false,
      },
    };
  }
  render() {
    const { myusername } = this.props;
    //  let menujson = Menu();
    // console.log(menujson);

    let checkstatus = checkUserLogin(this.props, myusername);

    if (checkstatus != "") return checkstatus;

    return (
      <div
        className="container wrap"
        style={{ height: "100%", paddingBottom: "90px", width: "90%" }}
      >
        <div className="pagetitle">
          <div style={{ float: "left" }}>
            <Link to={"/user/gift/list"}>Gift List</Link>{" "}
            <img src={rjt} style={{ width: "18px", height: "18px" }} />{" "}
            {this.state.title}
          </div>
          <div
            style={{
              float: "right",
            }}
          >
            <div
              style={{}}
              onClick={() => {
                window.history.back(-1);
              }}
            >
              <span className="iconfont fanhui">&#xe625;</span>
            </div>
          </div>
        </div>
        {/* <div className="pagetitle">
          <Link to={"/user/branch/list"}>Branch List</Link>{" "}
          <img src={rjt} style={{ width: "18px", height: "18px" }} />{" "}
          {this.state.title}
        </div> */}
        <div className="row textright">
          <div>
            <Link to="/user/gift/List">
              <input
                type="button"
                name="button1"
                value="Gift List"
                className="add"
              ></input>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 form">
            {/* <div className={this.state.uptype === "1" ? "row" : "nodis"}>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 ">
                姓名:
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 ">
                <input
                  value={this.state.upgzhnickname}
                  onChange={this.changeFirstName.bind(this)}
                />
              </div>
            </div> */}
            <div className={"row"}>
              <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                * Gift Code:
              </div>
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input
                  value={this.state.giftcode}
                  readOnly={this.state.editid == "" ? false : true}
                  onChange={(ref) => this.changeField(ref, "giftcode")}
                />
              </div>
            </div>
            <div className={"row"}>
              <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                * Gift Type:
              </div>
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input
                  type="radio"
                  name="gifttype"
                  value="price"
                  onChange={(ref) => this.setRadio(ref, "gifttype")}
                  checked={this.state.gifttype == "price" ? true : false}
                  style={{
                    width: "18px",
                    height: "18px",
                  }}
                ></input>
                {" Price  "}
                <input
                  type="radio"
                  name="gifttype"
                  value="service"
                  onChange={(ref) => this.setRadio(ref, "gifttype")}
                  checked={this.state.gifttype == "service" ? true : false}
                  style={{
                    width: "18px",
                    height: "18px",
                  }}
                ></input>
                {" Service "}
              </div>
            </div>
            {this.state.gifttype == "service" && (
              <div className={"row"}>
                <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                  Select Service:
                </div>
                <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                  {this.state.servicelist.map((item, index) => {
                    let selected = false;
                    let _item = this.state.selectedlist.find(
                      (tmpitem) => tmpitem.id === item.id
                    );
                    if (_item != null) {
                      selected = true;
                    }

                    return (
                      <div className="row list " key={"group" + index}>
                        <div
                          className="col-xs-1 col-sm-1 col-md-1 col-lg-1 "
                          style={{
                            display: "flex",

                            alignContent: "center",
                          }}
                        >
                          <input
                            type="checkbox"
                            name="serviceid"
                            value="Y"
                            onChange={(ref) => this.setCheck(ref, index)}
                            checked={selected}
                            style={{
                              width: "18px",
                              height: "18px",
                            }}
                          ></input>
                        </div>

                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                          $ {item.price} {" " + item.catename}
                        </div>
                        <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 ">
                          {item.title}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <div className={"row"}>
              <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                * Gift Price:
              </div>
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input
                  value={this.state.price}
                  onChange={(ref) => this.changeField(ref, "price")}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 textcenter">
                <button className="submit" onClick={() => this.submit()}>
                  Submit
                </button>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textcenter postresult"
                style={{ width: "70%", marginTop: "10px" }}
              >
                {this.state.postresult}
              </div>
            </div>
          </div>
        </div>
        {this.state.mytoast.show ? MyToast(this.state.mytoast) : null}
      </div>
    );
  }

  setRadio(ref, field) {
    let val = ref.target.value;
    if (field == "gifttype")
      this.setState({
        gifttype: val,
      });
    else if (field == "received") {
      this.setState({
        received: val,
      });
    }
  }
  setCheck(ref, index) {
    let selectedlist = this.state.selectedlist;
    if (ref.target.checked) {
      let item = {
        id: this.state.servicelist[index].id,
        title: this.state.servicelist[index].title,
      };
      let selected = this.state.selectedlist;
      selectedlist.push(item);
    } else {
      let _item = this.state.selectedlist.find(
        (tmpitem) => tmpitem.id === this.state.servicelist[index].id
      );
      if (_item != null) {
        let index = this.state.selectedlist.indexOf(_item);
        selectedlist.splice(index, 1);
      }
    }

    this.setState({
      selectedlist: selectedlist,
    });
  }
  changeField(e, field) {
    let val = e.target.value;
    if (field == "giftcode")
      this.setState({
        giftcode: val,
      });
    else if (field == "price") {
      if (!isNaN(val)) {
        this.setState({
          price: val,
        });
      } else {
        MyToastShow(
          this,
          2,
          "Please fill in number! ",
          150,
          80,
          "faise",
          "addbranch"
        );
      }
    } else if (field == "ec_policynumber") {
      this.setState({
        ec_policynumber: val,
      });
    } else if (field == "ec_certificated")
      this.setState({
        ec_certificated: val,
      });
    else if (field == "ec_secondmembername")
      this.setState({
        ec_secondmembername: val,
      });
  }
  submit() {
    const { myusername, ukey } = this.props;

    //console.log(this.state.pages);
    // document.getElementById("result2").style.color = "#000000";
    //

    this.setState({
      postresult: "Waiting....",
    });
    // document.getElementById("result2").innerHTML = "正在提交....";
    let service = this.state.selectedlist;
    if (this.state.gifttype == "price") {
      service = [];
      this.setState({
        selectedlist: service,
      });
    }
    const postdata = {
      uid: myusername,
      editid: this.state.editid,
      gifttype: this.state.gifttype,
      giftcode: this.state.giftcode,
      price: this.state.price,
      service: service,
    };
    const this2 = this;
    var error = "";

    if (this.state.giftcode === "") error = "Please fill in gift code";
    else if (this.state.price == "") error = "Please fill in gift price";
    else if (
      this.state.gifttype == "service" &&
      this.state.selectedlist.length == 0
    )
      error = "Please select service";
    //document.getElementById("result2").style.color = "red";
    if (error !== "") {
      this.setState({
        postresult: error,
      });
    } else {
      $.ajax({
        type: "POST",
        dataType: "json",
        url:
          AJAROOT +
          "/postaja/savexx.aspx?action=savegift&u=" +
          myusername +
          "&ukey=" +
          encodeURIComponent(ukey) +
          "",
        data: JSON.stringify(postdata),
      })
        .done(function (data) {
          var r = data.r;

          if (r === 1) {
            //  this.postresult = "登陆成功！";
            MyToastShow(
              this2,
              2,
              "Successfully! ",
              150,
              80,
              "success",
              "addbranch"
            );
            this2.setState({
              postresult: "Successfully! ",
            });

            this2.props.history.push("/user/gift/list");
          } else {
            MyToastShow(this2, 2, data.s, 200, 120, "fail", "addbranch");
            //document.getElementById("result2").style.color = "red";
            this2.setState({
              postresult: data.s,
            });

            //  document.getElementById("result2").innerHTML = msg;
          }
        })
        .fail(function (xhr, textStatus, errorThrown) {});
    }
  }

  componentDidMount() {
    const { myusername, ukey } = this.props;
    var { id } = queryString.parse(this.props.location.search);
    if (id == undefined) id = "";

    var title = "Add Gift";

    if (id != "") {
      title = "Edit Gift";
    }
    document.title = title;
    this.setState({
      title: title,
      editid: id,
    });

    getUserIndexData(this, myusername, ukey);
    if (id != "") this.getData(myusername, encodeURIComponent(ukey), id);

    this.getServiceData(myusername, encodeURIComponent(ukey));

    //  MyToastShow(this, 200, "Successfully! ", 150, 80, "success", "addgroup");
  }

  getServiceData(myusername, ukey) {
    var geturl =
      AJAROOT +
      "/getaja/xx.aspx?u=" +
      myusername +
      "&ukey=" +
      ukey +
      "&opened=1&action=servicelist";
    console.log(geturl);
    axios.get(geturl).then((res) => {
      const result = res.data;
      console.log(result);
      this.setState({
        servicelist: result.list,
      });
      // this.setState({}); /**/
    });
  }
  getData(myusername, ukey, id) {
    var geturl =
      AJAROOT +
      "/getaja/xx.aspx?u=" +
      myusername +
      "&ukey=" +
      ukey +
      "&action=giftinfo&id=" +
      id +
      "";

    axios.get(geturl).then((res) => {
      const result = res.data;
      console.log(result);
      //  let groupright = eval(result.groupright);

      this.setState({
        editid: result.id,
        giftcode: result.giftcode,
        gifttype: result.gifttype,
        price: result.price,
        selectedlist: result.service,
      });

      // this.setState({}); /**/
    });
  }
  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  componentWillUpdate() {}
  componentDidUpdate() {}
}

const mapStateToProps = (state) => {
  return {
    myusername: state.getIn(["gdata", "username"]),
    myusertype: state.getIn(["gdata", "usertype"]),
    myusergrade: state.getIn(["gdata", "usergrade"]),
    ukey: state.getIn(["gdata", "ukey"]),
    cartnum: state.getIn(["gdata", "cartnum"]),
  };
};

export default connect(mapStateToProps, null)(Index);
